module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.1068/img/InterstitialBlobs.png"